import ApiUris from "./apiUris";
import { postData } from "./base-api";
import { localStorageItemNames } from "../constants";

const createActivityId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();

  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));
  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex
    .slice(6, 8)
    .join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
};

const addLoggedInUserId = (payload) => {
  const userId = localStorage.getItem(localStorageItemNames.userID);
  const defaultUserId = /^[1-9]\d*$/.test(userId || "")
    ? Number(userId)
    : undefined;

  return {
    ...payload,
    userId: payload?.userId ?? defaultUserId,
  };
};

const postActivity = async (url, payload, token, keepalive = false) => {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(addLoggedInUserId(payload)),
    keepalive,
  });

  if (!response.ok) {
    const error = new Error(
      `Activity API returned HTTP ${response.status}.`,
    );
    error.status = response.status;
    throw error;
  }

  return response;
};

const recordEvent = async (moduleName, activityTitle, userId, token) => {
  if (!token || !/^[1-9]\d*$/.test(String(userId || ""))) return;

  const payload = {
    userId: Number(userId),
    sessionId: createActivityId(),
    instanceId: createActivityId(),
    moduleName,
    activityTitle: activityTitle.slice(0, 200),
    idleTimeMilliseconds: 0,
  };

  await moduleActivityApi.start(payload, token);
  await moduleActivityApi.exit(payload, token);
};

export const moduleActivityApi = {
  getUsageReport: (request) =>
    postData(ApiUris.moduleActivityApi.usageReport, addLoggedInUserId(request)),
  start: (payload, token) =>
    postActivity(ApiUris.moduleActivityApi.start, payload, token),
  heartbeat: (payload, token) =>
    postActivity(ApiUris.moduleActivityApi.heartbeat, payload, token),
  exit: (payload, token, keepalive = false) =>
    postActivity(ApiUris.moduleActivityApi.exit, payload, token, keepalive),
  recordEvent,
};
